module.exports = __webpack_public_path__ + "img/兰州维多丽亚.f49d7ef.png";